// Essentials. For important and other common states.
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccessControl } from "../types";
import { User } from "@auth0/auth0-react";
import { AuthUser } from "../types/AuthUser";

interface EsntlState {
  user?: AuthUser;
}

const initialState: EsntlState = {
    user: undefined,
};

const esntlSlice = createSlice({
  name: "esntl",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<AuthUser>) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = undefined;
    },
  },
});

export const { setUser, clearUser } = esntlSlice.actions;

export default esntlSlice.reducer;
